import React from 'react'
import './styles.less'

const SkeletonAboutUs = () => {
  return (
    <div className='skeletonAboutUs'>
      <div className="skeletonAboutUs__left">
        <div className="skeletonAboutUs__left__title"></div>
        <div className="skeletonAboutUs__left__text"></div>
        <div className="skeletonAboutUs__left__text"></div>
        <div className="skeletonAboutUs__left__text"></div>
        <div className="skeletonAboutUs__left__text"></div>

        <div className="skeletonAboutUs__left__title"></div>
        <div className="skeletonAboutUs__left__text"></div>
        <div className="skeletonAboutUs__left__text"></div>
        <div className="skeletonAboutUs__left__text"></div>
        <div className="skeletonAboutUs__left__text"></div>
      </div>
      <div className="skeletonAboutUs__right">
        <div className="skeletonAboutUs__right__title"></div>
        <div className="skeletonAboutUs__right__text"></div>
        <div className="skeletonAboutUs__right__text"></div>
        <div className="skeletonAboutUs__right__text"></div>
        <div className="skeletonAboutUs__right__text"></div>
      </div>
    </div>
  )
}

export default SkeletonAboutUs